<template>
  <div class="value-list-create-page">
    <v-container fluid class="px-6 py-4">
      <!-- Page Header -->
      <div class="page-header mb-6">
        <div class="header-content">
          <div class="page-title-section">
            <div class="d-flex align-center mb-2">
              <v-btn
                icon
                color="primary"
                @click="$router.back()"
                class="back-btn mr-3"
              >
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>
              <h1 class="page-title">
                <v-icon large class="title-icon mr-3">mdi-format-list-bulleted-square</v-icon>
                Add New Value List
              </h1>
            </div>
            <p class="page-subtitle">
              Create a new value list for the system
            </p>
          </div>
        </div>
      </div>

      <!-- Value List Form Card -->
      <v-card class="value-list-form-card" elevation="8">
        <v-card-title class="modern-card-title">
          <h2 class="card-title">
            <v-icon class="mr-2">mdi-form-select</v-icon>
            Value List Information
          </h2>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="6">
              <v-text-field
                v-model="form.name"
                outlined
                label="Value List Name *"
                prepend-inner-icon="mdi-format-list-bulleted-square"
                :error-messages="errors.name"
                class="modern-input"
                background-color="grey lighten-5"
              ></v-text-field>
            </v-col>
            <v-col sm="6">
              <v-textarea
                v-model="form.description"
                outlined
                label="Description"
                prepend-inner-icon="mdi-text"
                rows="3"
                class="modern-input"
                background-color="grey lighten-5"
              ></v-textarea>
            </v-col>
          </v-row>
          
          <v-divider class="my-5"></v-divider>
          
          <div class="form-actions mt-6">
            <v-btn
              :loading="isLoading"
              :disabled="isLoading"
              color="primary"
              large
              class="modern-btn"
              @click="save"
              elevation="2"
            >
              <v-icon left>mdi-content-save</v-icon>
              Save Value List
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>
<script>
import axios from "@/axios";
export default {
  name: "ValueListCreatePage",
  data() {
    return {
      form: {
        name: "",
        description: "",
      },
      isLoading: false,
    };
  },
  methods: {
    async save() {
      try {
        this.isLoading = true;
        await axios.post("value-lists", this.form);
        await this.saveUserTimestamp(null, this.form);
        this.isLoading = false;
        this.$router.push("/value-lists");
      } catch (e) {
        console.log(e);
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.value-list-create-page {
  min-height: calc(100vh - 64px);
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
}

/* Page Header */
.page-header {
  background: white;
  border-radius: 20px;
  padding: 32px;
  box-shadow: 0 10px 40px rgba(102, 126, 234, 0.1);
  border: 1px solid rgba(102, 126, 234, 0.1);
  position: relative;
  overflow: hidden;
}

.page-header::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.page-title {
  font-size: 32px;
  font-weight: 700;
  color: #2c3e50;
  margin: 0;
  display: flex;
  align-items: center;
}

.title-icon {
  color: #667eea !important;
}

.page-subtitle {
  font-size: 16px;
  color: #64748b;
  margin: 8px 0 0 0;
  font-weight: 400;
}

.back-btn {
  background: rgba(102, 126, 234, 0.1) !important;
  border: 1px solid rgba(102, 126, 234, 0.2) !important;
  transition: all 0.3s ease;
}

.back-btn:hover {
  background: rgba(102, 126, 234, 0.15) !important;
  transform: translateX(-2px);
}

/* Form Card */
.value-list-form-card {
  border-radius: 20px !important;
  border: 1px solid rgba(102, 126, 234, 0.1);
  background: white;
  overflow: hidden;
  box-shadow: 0 10px 40px rgba(102, 126, 234, 0.1) !important;
}

.modern-card-title {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-bottom: 1px solid rgba(102, 126, 234, 0.1);
  padding: 24px 32px !important;
}

.card-title {
  font-size: 22px;
  font-weight: 600;
  color: #2c3e50;
  margin: 0;
  display: flex;
  align-items: center;
}

/* Form Elements */
.modern-input >>> .v-input__control .v-input__slot {
  border-radius: 12px !important;
  transition: all 0.3s ease;
  border-color: rgba(102, 126, 234, 0.2) !important;
}

.modern-input >>> .v-input__control .v-input__slot:hover {
  border-color: #667eea !important;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.1);
}

.modern-input >>> .v-input--is-focused .v-input__control .v-input__slot {
  border-color: #667eea !important;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);
}

.modern-input >>> .v-text-field__prefix,
.modern-input >>> .v-text-field__suffix {
  color: #667eea !important;
}

/* Form Actions */
.form-actions {
  text-align: center;
  padding: 24px 0;
}

.modern-btn {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  letter-spacing: 0.5px !important;
  padding: 0 32px !important;
  height: 48px !important;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
  color: white !important;
  transition: all 0.3s ease;
}

.modern-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.4) !important;
}

.modern-btn:before {
  background-color: transparent;
}

/* Dividers */
.v-divider {
  border-color: rgba(102, 126, 234, 0.1) !important;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .page-header {
    padding: 24px;
  }
  
  .page-title {
    font-size: 28px;
  }
  
  .modern-card-title {
    padding: 20px 24px !important;
  }
}

@media (max-width: 600px) {
  .page-header {
    padding: 20px 16px;
  }
  
  .page-title {
    font-size: 24px;
    flex-direction: column;
    gap: 8px;
    text-align: center;
  }
  
  .modern-card-title {
    padding: 16px 20px !important;
  }
  
  .card-title {
    font-size: 20px;
    flex-direction: column;
    gap: 8px;
    text-align: center;
  }
  
  .form-actions {
    padding: 16px 0;
  }
  
  .modern-btn {
    width: 100%;
    margin-bottom: 12px;
  }
}

/* Animation for page entrance */
.value-list-form-card {
  animation: slideUp 0.6s ease-out;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>